import { render } from "./menu-top.vue?vue&type=template&id=55a6abbe&scoped=true"
import script from "./menu-top.vue?vue&type=script&lang=js"
export * from "./menu-top.vue?vue&type=script&lang=js"

import "./menu-top.vue?vue&type=style&index=0&id=55a6abbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a6abbe"]])

export default __exports__